import apiClient from '../api';

export const fetchProductOptions = async (isAdataBrandsOnly = false) => {
  try {
    const params = {};
    if (isAdataBrandsOnly) {
      params.is_adata_product = true;
    }
    const response = await apiClient.get('/ci/products/options', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching product options:', error);
    throw error;
  }
};

export const fetchBrandOptions = async (isAdataBrandsOnly = false) => {
  try {
    const params = {};
    if (isAdataBrandsOnly) {
      params.is_adata_brand = true;
    }
    const response = await apiClient.get('/ci/brands/options', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching brand options:', error);
    throw error;
  }
};

export const fetchCategoryOptions = async () => {
  try {
    const response = await apiClient.get('/ci/categories/options');
    return response.data;
  } catch (error) {
    console.error('Error fetching category options:', error);
    throw error;
  }
};

export const performProductPricingAnalysis = async (payload) => {
  try {
    const response = await apiClient.post('/ci/product-pricing-analysis', payload);
    return response.data;
  } catch (error) {
    console.error('Error performing product pricing analysis:', error);
    throw error;
  }
};

export const performThreatAssessment = async (payload) => {
  try {
    const response = await apiClient.post('/ci/threat-assessment', payload);
    return response.data;
  } catch (error) {
    console.error('Error performing threat assessment:', error);
    throw error;
  }
};

export const performPricePositioningAnalysis = async (payload) => {
  try {
    const response = await apiClient.post('/ci/price-positioning-analysis', payload);
    return response.data;
  } catch (error) {
    console.error('Error performing price positioning analysis:', error);
    throw error;
  }
};

export const performSKULandscapeAnalysis = async (payload) => {
  try {
    const response = await apiClient.post('/ci/sku-landscape-analysis', payload);
    return response.data;
  } catch (error) {
    console.error('Error performing SKU landscape analysis:', error);
    throw error;
  }
};
